import { render, staticRenderFns } from "./PromotionInvitationSubmissionForm.vue?vue&type=template&id=353835a8"
import script from "./PromotionInvitationSubmissionForm.vue?vue&type=script&lang=js"
export * from "./PromotionInvitationSubmissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports